import removeEventListener from 'dom-helpers/events/off';
import addEventListener from 'dom-helpers/events/on';
import * as React from 'react';

interface Props {
    onTickChange: (curScrollTickCount: number) => void;
    scrollAmountPerTick: number;
    className: string;
}

interface State {
    lastY: number | null;
    bgPos: number;
    scrollDiff: number;
    scrollTickCount: number;
}

export default class ScrollWheel extends React.PureComponent<Props, State> {
    static defaultProps = {
        scrollAmountPerTick: 10,
        className: '',
    };

    containerNode: React.ReactNode = null;

    constructor(props: Props) {
        super(props);

        this.state = {
            lastY: null,
            bgPos: 0,
            scrollDiff: 0,
            scrollTickCount: 0,
        };
    }

    componentDidMount() {
        addEventListener(this.containerNode, 'touchmove', this.handleTouchMove, { passive: false });
        addEventListener(this.containerNode, 'touchend', this.handleTouchEnd, { passive: false });
    }

    componentWillUnmount() {
        removeEventListener(this.containerNode, 'touchmove', this.handleTouchMove);
        removeEventListener(this.containerNode, 'touchend', this.handleTouchEnd);
    }

    handleTouchMove = (evt: React.TouchEvent): void => {
        const { lastY, scrollDiff, scrollTickCount } = this.state;
        const { scrollAmountPerTick, onTickChange } = this.props;
        const { screenY } = evt.touches[0];

        evt.preventDefault();
        evt.stopPropagation();

        if (lastY == null) {
            this.setState({
                lastY: screenY,
            });
        } else {
            const curScrollTickCount = Math.floor((scrollDiff + (lastY - screenY)) / scrollAmountPerTick);
            if (curScrollTickCount !== scrollTickCount) {
                onTickChange(curScrollTickCount);
            }

            this.setState((prevState: State, props: Props) => ({
                scrollDiff: prevState.scrollDiff + ((prevState.lastY ? prevState.lastY : 0) - screenY),
                bgPos: prevState.bgPos + ((prevState.lastY ? prevState.lastY : 0) - screenY),
                scrollTickCount: Math.floor(
                    (prevState.scrollDiff + ((prevState.lastY ? prevState.lastY : 0) - screenY)) / scrollAmountPerTick,
                ),
                lastY: screenY,
            }));
        }
    };

    handleTouchEnd = (evt: React.TouchEvent): void => {
        this.setState({
            lastY: null,
        });
    };

    reset = (): void => {
        this.setState({
            lastY: null,
            scrollDiff: 0,
            scrollTickCount: 0,
        });
    };

    render() {
        const { className } = this.props;
        const { bgPos } = this.state;
        const styles = {
            backgroundPosition: `center ${bgPos * -1}px`,
        };

        const classNames: Array<string> = [className, 'ddbc-scrollwheel'];

        return (
            <div
                className={classNames.join(' ')}
                ref={(node) => {
                    this.containerNode = node;
                }}
            >
                <div className="ddbc-scrollwheel__bg" />
                <div className="ddbc-scrollwheel__wheel">
                    <div className="ddbc-scrollwheel__wheel-scroll" style={styles} />
                    <div className="ddbc-scrollwheel__wheel-bg" />
                </div>
            </div>
        );
    }
}
